"use client";

import Link from "next/link";
import Header from "@/components/layout/header";
import Footer from "@/components/layout/footer";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow flex items-center justify-center bg-white">
        <div className="text-center px-4">
          <h1 className="text-[50px] md:text-[80px] font-bold text-[#920000]">
            404
          </h1>
          <p className="text-[24px] md:text-[32px] font-[500] mb-8 text-gray-600 font-['Ainslie_Sans']">
            Page not found
          </p>
          <Link
            href="/"
            aria-label="Back to Home"
            className="inline-block bg-[#920000] text-white px-8 py-3 rounded-md 
                     text-[18px] font-[500] font-['Ainslie_Sans'] hover:bg-[#cc0000] 
                     transform hover:scale-105 transition-all duration-300"
          >
            Back to Home
          </Link>
        </div>
      </main>
    </div>
  );
}
